import * as z from "zod/v4";

const conversionMetricsSchema = z.object({
  sessions: z.number(),
  orders: z.number(),
  conversionRate: z.number(),
  totalSales: z.number(),
});

const dailyDataSchema = z.object({
  date: z.string(),
  sessions: z.number(),
  orders: z.number(),
  conversionRate: z.number(),
  totalSales: z.number(),
});

export const getMerchantShopifyStats = {
  name: "getMerchantShopifyStats" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    team: z
      .object({
        teamId: z.string(),
        teamName: z.string().nullable(),
        storeUrl: z.string().nullable(),
        installedAt: z.date().nullable(),
        hasRequiredScopes: z.boolean(),
        totalMetrics: conversionMetricsSchema,
        dailyData: z.array(dailyDataSchema),
        lastUpdated: z.date().nullable(),
        /** Team's coverage price (backend/rev share portion) */
        teamPricePerOrder: z.number().nullable(),
      })
      .nullable(),
  }),
};

export type ConversionMetrics = z.infer<typeof conversionMetricsSchema>;
export type DailyData = z.infer<typeof dailyDataSchema>;
export type GetMerchantShopifyStatsInput = z.infer<
  typeof getMerchantShopifyStats.input
>;
export type GetMerchantShopifyStatsOutput = z.infer<
  typeof getMerchantShopifyStats.output
>;
